// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"4441ff3e","98":"dcc7e30f","155":"9c2d1581","217":"e901dca5","426":"89740e26","528":"30575e26","536":"ddb63cc6","787":"c6d211e3","928":"34538e06"}[chunkId] + ".chunk.js";
};